

/*
*组件索引，并注册组件
*18-07-03
*/

var asynComponent = {};

// if (process.env.NODE_ENV === 'development') {
//     asynComponent = {
//         login: require('src/views/common/login/login.vue'),
//         home: require('src/views/common/home/home.vue'),
//         roleManage: require('src/views/role-manage/role-manage.vue'),
//         userManage: require('src/views/user-manage/user-manage.vue')
//     };
// } else {
asynComponent = {
    login: resolve => require(['src/views/common/login/login.vue'], resolve),
    home: resolve => require(['src/views/common/home/home.vue'], resolve),
    roleManage: resolve => require(['src/views/role-manage/role-manage.vue'], resolve),
    userManage: resolve => require(['src/views/user-manage/user-manage.vue'], resolve),
    menuManage: resolve => require(['src/views/menu-manage/menu-manage.vue'], resolve),
    pileManage: resolve => require(['src/views/pile-manage/pile-manage.vue'], resolve),
    stationManage: resolve => require(['src/views/station-manage/station-manage.vue'], resolve),
    chargeRule: resolve => require(['src/views/charge-rule/charge-rule.vue'], resolve),
    pileMonitor: resolve => require(['src/views/pile-monitor/pile-monitor.vue'], resolve),
    serviceMonitor: resolve => require(['src/views/service-monitor/service-monitor.vue'], resolve),
    dispatchManage: resolve => require(['src/views/dispatch-manage/dispatch-manage.vue'], resolve),
    brandManage: resolve => require(['src/views/brand-manage/brand-manage.vue'], resolve),
    errorMsg: resolve => require(['src/views/error-msg/error-msg.vue'], resolve),
    errorStrategy: resolve => require(['src/views/error-strategy/error-strategy.vue'], resolve),
    mapBoard: resolve => require(['src/views/map-board/map-board.vue'], resolve),
    message: resolve => require(['src/components/message/message.vue'], resolve),
    bizDashBoard: resolve => require(['src/views/biz-dash-board/biz-dash-board.vue'], resolve),
    companyManage: resolve => require(['src/views/company-manage/company-manage.vue'], resolve),
    orderManage: resolve => require(['src/views/order-manage/order-manage.vue'], resolve),
    userBg: resolve => require(['src/views/user-bg/user-bg.vue'], resolve),
    exportManage: resolve => require(['src/views/export-manage/export-manage.vue'], resolve),
    whiteMgr: resolve => require(['src/views/white-manage/white-manage.vue'], resolve),
    myMember: resolve => require(['src/views/my-member/my-member.vue'], resolve),
    operateAnalysis: resolve => require(['src/views/operate-analysis/operate-analysis.vue'], resolve),
    operationLog: resolve => require(['src/views/operation-log/operation-log.vue'], resolve),
    incomeReport: resolve => require(['src/views/income-report/income-report.vue'], resolve),
    stationReport: resolve => require(['src/views/station-report/station-report.vue'], resolve),
    activity: resolve => require(['src/views/activity-manage/activity-manage.vue'], resolve),
    discount: resolve => require(['src/views/discount-manage/discount-manage.vue'], resolve),
    coupon: resolve => require(['src/views/coupon/coupon.vue'], resolve),
    userCard: resolve => require(['src/views/user-card/user-card.vue'], resolve),
    wxConfig: resolve => require(['src/views/wx-config/wx-config.vue'], resolve),
    powerMonitor: resolve => require(['src/views/power-monitor/power-monitor.vue'], resolve),
    customerManage: resolve => require(['src/views/customer-manage/customer-manage.vue'], resolve),
    softwareVersion: resolve => require(['src/views/software-version/software-version.vue'], resolve),
    sigManage: resolve => require(['src/views/sig-manage/sig-manage.vue'], resolve),
    stationInfoManage: resolve => require(['src/views/station-info-manage/station-info-manage.vue'], resolve),
    stationInfoPush: resolve => require(['src/views/station-info-push/station-info-push.vue'], resolve),
    invoiceManage: resolve => require(['src/views/invoice-manage/invoice-manage.vue'], resolve),
    stationEventPush: resolve => require(['src/views/station-event-push/station-event-push.vue'], resolve),
    dataStatistical: resolve => require(['src/views/data-statistical/data-statistical.vue'], resolve),
    countStation: resolve => require(['src/views/count-station/count-station.vue'], resolve),
    countDaily: resolve => require(['src/views/count-daily/count-daily.vue'], resolve),
    countPile: resolve => require(['src/views/count-pile/count-pile.vue'], resolve),
    carManage: resolve => require(['src/views/car-manage/car-manage.vue'], resolve),
    chargingReality: resolve => require(['src/views/charging-reality/charging-reality.vue'], resolve),
    groupCard: resolve => require(['src/views/group-card/group-card.vue'], resolve),
    cardPayLog: resolve => require(['src/views/user-card/card-pay-log/card-pay-log.vue'], resolve),
    groupOrder: resolve => require(['src/views/group-order/group-order.vue'], resolve)
};
// }


export default asynComponent;


// WEBPACK FOOTER //
// ./src/router/component.js